import React, { useState } from 'react';
import styles from '../styles/stylesPortfolioCardDesktop';

function PortfolioCardDesktop({
  image,
  icon,
  title,
  link,
  topImage,
  topImageOffset,
  gradientImage,
  isActive
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        ...styles.cardOuterBorder,
        ...(isHovered ? styles.cardOuterBorderHover : {}),
        // filter: isActive ? 'brightness(1)' : 'brightness(0.6)',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.iconWrapper}>
        <img src={icon} alt="Project Icon" style={styles.icon} />
      </div>

      <div style={styles.card}>
        <img src={gradientImage} alt="Gradient Background" style={styles.cardImage} />
        <div style={{...styles.cardBlur, filter: 'opacity(1)'}}></div>

        <h3 style={styles.projectTitle}>{title}</h3>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.projectImageWrapper}
        >
          <img src={image} alt="Project Preview" style={{...styles.projectImage}} />
        </a>

        {topImage && (
          <div
            style={{
              ...styles.topImageWrapper,
              transform: `translate(-50%, ${topImageOffset})`,
            }}
          >
            <img src={topImage} alt="Mockup" style={styles.topImage} />
          </div>
        )}
      </div>
    </div>
  );
}

export default PortfolioCardDesktop;
